import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

const KEY = Symbol('ignoreInMouseCatcher');

export function makeMouseEventListener<E extends React.MouseEvent>(
  listener: (v: E) => void,
) {
  return (e: E) => {
    if ((e as any)[KEY]) {
      return;
    }
    listener(e);
  };
}

export function MouseCatcherIgnoreEvents({
  children,
}: {
  children: React.ReactNode;
}) {
  const mouseProps: React.HTMLAttributes<HTMLDivElement> = useMemo(() => {
    const markToIgnore = (e: React.MouseEvent<HTMLDivElement>) => {
      (e as any)[KEY] = true;
    };
    return {
      onMouseDown: markToIgnore,
      onMouseUp: markToIgnore,
      onMouseMove: markToIgnore,
      onMouseLeave: markToIgnore,
      onMouseEnter: markToIgnore,
      onClick: markToIgnore,
      onDoubleClick: markToIgnore,
      onContextMenu: markToIgnore,
    };
  }, []);

  if (ReactDOM.version.startsWith('18')) {
    return <div {...mouseProps}>{children}</div>;
  }
  return children as React.ReactElement;
}
